var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyegreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#219653"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 9.08773C14.1392 8.80522 15.067 8.66296 16 8.66607C19.8335 8.66607 22.4423 10.9577 23.9979 12.9781C24.7771 13.9919 25.1666 14.497 25.1666 15.9994C25.1666 17.5027 24.7771 18.0078 23.9979 19.0207C22.4423 21.0411 19.8335 23.3327 16 23.3327C12.1665 23.3327 9.55765 21.0411 8.00206 19.0207C7.2229 18.0087 6.83331 17.5018 6.83331 15.9994C6.83331 14.4961 7.2229 13.991 8.00206 12.9781C8.47736 12.3573 9.00649 11.7797 9.58331 11.252",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16C18.75 16.7293 18.4603 17.4288 17.9445 17.9445C17.4288 18.4603 16.7293 18.75 16 18.75C15.2707 18.75 14.5712 18.4603 14.0555 17.9445C13.5397 17.4288 13.25 16.7293 13.25 16C13.25 15.2707 13.5397 14.5712 14.0555 14.0555C14.5712 13.5397 15.2707 13.25 16 13.25C16.7293 13.25 17.4288 13.5397 17.9445 14.0555C18.4603 14.5712 18.75 15.2707 18.75 16Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyegreen);
export default __webpack_public_path__ + "static/media/eyegreen.6ae5dbff2f0e712c6638824e3777311c.svg";
export { ForwardRef as ReactComponent };